import axiosClient from "./axiosClient";

export const listarGastosFijos = (cuentaId, mes, anio) =>
  axiosClient.get(`/gastos-fijos/cuenta/${cuentaId}`, { params: { mes, anio } }).then((r) => r.data);
export const upsertGastoFijo = (data) => axiosClient.post("/gastos-fijos", data).then((r) => r.data);
export const marcarPagado = (id, pagado) => axiosClient.patch(`/gastos-fijos/${id}/pagado`, { pagado });
export const eliminarGastoFijo = (id) => axiosClient.delete(`/gastos-fijos/${id}`);
export const cambiarEstado = (id, nuevoEstado) => axiosClient.post(`/gastos-fijos/${id}/estado`, { nuevoEstado });
export const activarTodosEnEspera = (cuentaId, mes, anio) =>
  axiosClient.post(`/gastos-fijos/cuenta/${cuentaId}/activar-en-espera`, null, { params: { mes, anio } });
export const liquidar = (id) => axiosClient.post(`/gastos-fijos/${id}/liquidar`);
export const liquidarTodo = (cuentaId, mes, anio) =>
  axiosClient.post(`/gastos-fijos/cuenta/${cuentaId}/liquidar-todo`, null, { params: { mes, anio } });
